import type { FaireProductEntity } from "../../entity_types/product";

export const nopalera_6: FaireProductEntity = {
  token: "nopalera-6",
  type: "product",
  name: "Dulce de Cuerpo Cactus Body Creme - Deep Hydration",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c7dfe9a4a829b10df87af1248819dc30896e1ecfe40f18885bc85b20d263752e.webp",
  priceDollars: 24,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  weight: 0.5,
  dimensions: {
    width: 2.5,
    height: 4,
    depth: 2.5,
  },
  description: "Cactus body creme, deep hydration - Nopalera bestseller",
  categoryTokens: ["cat_bath-all"],
  tags: ["premium", "organic", "bestseller", "body-creme"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
